import { Paragraph, SentenceObject } from "../types";

/** Keeps preview subtitle events in sync when paragraph text is edited. */
export function syncParagraphWordsFromText(paragraph: Paragraph): Paragraph {
  const tokens = paragraph.text.trim()
    ? paragraph.text.trim().split(/\s+/)
    : [];

  if (tokens.length === 0) {
    return { ...paragraph, words: [] };
  }

  const existingWords = paragraph.words;
  const firstStart = existingWords[0]?.start ?? paragraph.start ?? null;
  const lastEnd =
    existingWords[existingWords.length - 1]?.end ?? paragraph.end ?? null;

  if (firstStart == null || lastEnd == null) {
    return {
      ...paragraph,
      words: tokens.map((word) => ({ word, start: null, end: null })),
    };
  }

  const span = lastEnd - firstStart;
  const step = span / tokens.length;

  const words: SentenceObject[] = tokens.map((word, index) => ({
    word,
    start: firstStart + index * step,
    end:
      index === tokens.length - 1 ? lastEnd : firstStart + (index + 1) * step,
  }));

  return { ...paragraph, words };
}
